<template>
  <section class="testimonials-section py-5">
    <div class="container">
      <div class="text-center mb-5">
        <span class="testimonials-eyebrow">Quem já usou</span>
        <h2 class="testimonials-title">Histórias reais de eventos 💫</h2>
      </div>

      <div class="row justify-content-center g-4">
        <div class="col-12 col-md-4" v-for="(item, i) in testimonials" :key="i">
          <div class="testimonial-card">
            <div class="testimonial-stars mb-2">
              <i class="fas fa-star" v-for="star in 5" :key="star"></i>
            </div>
            <p class="testimonial-text">{{ item.text }}</p>
            <div class="testimonial-author">
              <div class="testimonial-avatar">{{ item.author.charAt(0) }}</div>
              <cite class="testimonial-name">{{ item.author }}</cite>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const testimonials = [
  { text: '“Usei no casamento e foi incrível. Os convidados entenderam rápido e tudo ficou organizado.”', author: 'Marina e Rafael' },
  { text: '“No aniversário da minha filha conseguimos compartilhar a lista em minutos e deu super certo.”', author: 'Daniela Souza' },
  { text: '“A melhor parte foi poder receber os valores e transferir para minha conta sem dor de cabeça.”', author: 'João Pedro' },
];
</script>

<style scoped>
.testimonials-section {
  background: linear-gradient(135deg, #f7f8fc 0%, #fdf6fa 100%);
}

.testimonials-eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #ff50a3;
  margin-bottom: 0.5rem;
}

.testimonials-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #32355d;
}

.testimonial-card {
  background: #fff;
  border-radius: 1.25rem;
  padding: 1.5rem;
  border: 1px solid #f0f0f4;
  box-shadow: 0 10px 28px rgba(31, 42, 68, 0.06);
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.testimonial-stars i {
  color: #ffb400;
  font-size: 0.85rem;
}

.testimonial-text {
  color: #555f77;
  font-size: 0.95rem;
  line-height: 1.5;
  flex-grow: 1;
  margin: 0;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: auto;
}

.testimonial-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff50a3, #ff8cc8);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.testimonial-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: #32355d;
  font-style: normal;
}

@media (max-width: 767.98px) {
  .testimonials-title {
    font-size: 1.45rem;
  }

  .testimonial-card {
    padding: 1.2rem;
  }

  .testimonial-text {
    font-size: 0.92rem;
  }
}
</style>
